// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

/**
 * Named grouping for messages (e.g. the auto-seeded "Control" type).
 * Small, mostly-static lookup table — id is a fixed, hand-assigned
 * integer, not a generated one.
 */
export class MessageType implements flatbuffers.IUnpackableObject<MessageTypeT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): MessageType {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsMessageType(bb: flatbuffers.ByteBuffer, obj?: MessageType): MessageType {
    return (obj || new MessageType()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsMessageType(
    bb: flatbuffers.ByteBuffer,
    obj?: MessageType,
  ): MessageType {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new MessageType()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  name(): string;
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  name(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  color(): string | null;
  color(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  color(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedAt(): string | null;
  updatedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startMessageType(builder: flatbuffers.Builder) {
    builder.startObject(5);
  }

  static addId(builder: flatbuffers.Builder, id: number) {
    builder.addFieldInt32(0, id, 0);
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, nameOffset, 0);
  }

  static addColor(builder: flatbuffers.Builder, colorOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, colorOffset, 0);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, createdAtOffset, 0);
  }

  static addUpdatedAt(builder: flatbuffers.Builder, updatedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, updatedAtOffset, 0);
  }

  static endMessageType(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 6); // name
    return offset;
  }

  static createMessageType(
    builder: flatbuffers.Builder,
    id: number,
    nameOffset: flatbuffers.Offset,
    colorOffset: flatbuffers.Offset,
    createdAtOffset: flatbuffers.Offset,
    updatedAtOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    MessageType.startMessageType(builder);
    MessageType.addId(builder, id);
    MessageType.addName(builder, nameOffset);
    MessageType.addColor(builder, colorOffset);
    MessageType.addCreatedAt(builder, createdAtOffset);
    MessageType.addUpdatedAt(builder, updatedAtOffset);
    return MessageType.endMessageType(builder);
  }

  unpack(): MessageTypeT {
    return new MessageTypeT(
      this.id(),
      this.name(),
      this.color(),
      this.createdAt(),
      this.updatedAt(),
    );
  }

  unpackTo(_o: MessageTypeT): void {
    _o.id = this.id();
    _o.name = this.name();
    _o.color = this.color();
    _o.createdAt = this.createdAt();
    _o.updatedAt = this.updatedAt();
  }

  unpackFields(...fields: string[]): MessageTypeT {
    const t = new MessageTypeT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id();
    }
    if (fieldSet.has("name")) {
      t.name = this.name();
    }
    if (fieldSet.has("color")) {
      t.color = this.color();
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("updated_at")) {
      t.updatedAt = this.updatedAt();
    }
    return t;
  }
}

export class MessageTypeT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: number = 0,
    public name: string | Uint8Array | null = null,
    public color: string | Uint8Array | null = null,
    public createdAt: string | Uint8Array | null = null,
    public updatedAt: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.name === null || this.name === undefined) {
      throw new Error('Required field "name" is not set');
    }
    const name = this.name !== null ? builder.createString(this.name!) : 0;
    const color = this.color !== null ? builder.createString(this.color!) : 0;
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const updatedAt = this.updatedAt !== null ? builder.createString(this.updatedAt!) : 0;

    return MessageType.createMessageType(builder, this.id, name, color, createdAt, updatedAt);
  }

  clone(): MessageTypeT {
    const obj = new MessageTypeT();
    obj.id = this.id;
    obj.name = this.name;
    obj.color = this.color;
    obj.createdAt = this.createdAt;
    obj.updatedAt = this.updatedAt;
    return obj;
  }

  equals(other: MessageTypeT): boolean {
    if (this.id !== other.id) return false;
    if (this.name !== other.name) return false;
    if (this.color !== other.color) return false;
    if (this.createdAt !== other.createdAt) return false;
    if (this.updatedAt !== other.updatedAt) return false;
    return true;
  }
}

export function verifyMessageType(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 4);
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "name");
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
